import { Box } from '@mui/material';
import './ApiCredentials.scss';
import SPUserCard from '../../../components/SellerProfile/UserCard/SPUserCard';
import { useEffect} from 'react';
// import { SpAPIgetAllApiCreds } from '../../../pages/SellerProfile/APIs/ApiCredsAPI';
import { doFormErrorMsgs } from '../APIs/Helpers';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchAllApiCredentialStart } from '../../../redux/slices/apiCredentialSlice';
import { addNewUserInfoToUsersList } from '../../../pages/SellerProfile/APIs/Helpers';
import { sortUsers } from '../../../pages/SellerProfile/APIs/Helpers';
import { setUsers } from '../../../redux/slices/sellerProfileSlice';

function ApiCredentials() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { seller_id, users ,spPageText} = useSelector((state: any) => state.sellerProfile);
  const { loaded, newUserInfo } = useSelector((state: any) => state.apiCredential);

  useEffect(() => {
    try {
      if (seller_id) {
        dispatch(fetchAllApiCredentialStart({ language: i18n.language, seller_id }));
      }
    } catch (error) {
      doFormErrorMsgs(error,dispatch,spPageText);
      console.log('err-api', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, seller_id])

  useEffect(() => {
    const updatedUsers = addNewUserInfoToUsersList(users, newUserInfo);
    const sortedUsers = sortUsers(updatedUsers);
    dispatch(setUsers([...sortedUsers]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newUserInfo])

  return loaded ? (
    <Box className="spUpdateApiCredentials">
      <p className="spInstructions">{t('sellerProfile.dashboard.selectAdminAPIcreds')}</p>
      <SPUserCard cardType="env" />
    </Box>
  ) : (
    <></>
  );
}

export default ApiCredentials;
